<template>
	<div class="col-sm-12">
		<br />
		<div class="well well-sm">
			<div class="row">
				<div class="col-sm-6">
					<span>Empresa</span>
					<drop-draw
						v-model="data.cnpj"
						placeholder="PESQUISAR CLIENTE"
						:asset="assets.clientes"
						cod="cnpj"
						radio
						title="razao_social"
						@change="CarregarClienteParraAnalise"
					/>
				</div>
				<div class="col-sm-3">
					<span>Atividade Principal</span>
					<input
						disabled
						v-model="AtividadePrincipal"
						type="text"
						class="form-control"
					/>
				</div>
				<div class="col-sm-3">
					<span>Contrato</span>
					<select
						class="form-control"
						:disabled="contratos.length == 0"
						v-model="data.contrato"
					>
						<option
							v-for="(contrato, index) in contratos"
							:key="index"
							:value="contrato.cod"
						>
							{{ contrato.cod }}: R$
							{{ parseFloat(contrato.valor).toFixed(2) }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import dropDraw from 'dropdraw';
	import WBS from 'js/http';
	export default {
		inject: ['assets'],
		props: ['dataIn', 'AtividadePrincipal'],
		components: { dropDraw },
		data() {
			return {
				contratos: [],
			};
		},
		methods: {
			getEmail(emp) {
				if (emp.contatos.lenght == 0) return '';
				if (emp.contatos[emp.contato] == undefined) return '';
				return emp.contatos[emp.contato].mail;
			},
			CarregarClienteParraAnalise() {
				WBS.send(
					'public-custom-scnpj',
					{ new: 0, cnpj: this.data.cnpj },
					(resp) => {
						if (resp.status == 'success') {
							let atividades = resp.data.atividades_secundarias;
							atividades = atividades.concat(
								resp.data.atividade_principal
							);

							this.$emit('setDataHeader', {
								atividade_principal:
									resp.data.atividade_principal[0].code,
								atividades: atividades,
							});
						}
					}
				);
			},
		},
		watch: {
			'data.cnpj': function (val) {
				if (val == '') {
					this.contratos = [];
				} else {
					const cnpjSel = this.assets.clientes.find(
						(resp) => resp.cnpj == val
					);
					const contratosIds = cnpjSel.contratos.reduce(
						(acc, item) => {
							acc.push(item.cod);
							return acc;
						},
						[]
					);

					this.contratos = cnpjSel.contratos;
					this.data.email = this.getEmail(cnpjSel);
					if (contratosIds.indexOf(this.data.contrato) == -1) {
						this.data.contrato = cnpjSel.contratos[0].cod;
					}
				}
			},
		},
		computed: {
			data() {
				return this.dataIn;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/components/DadosEmpreas.vue